<div>
  <div class="relative">
    <div
      class="relative flex h-12 items-center rounded-xl border bg-lGray950 transition-colors"
      [class.border-lPrimary]="isOpen"
      [class.border-transparent]="!isOpen"
      [class.opacity-60]="isDisabled"
    >
      <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600" icon="search" />

      <input
        [id]="inputId"
        type="text"
        autocomplete="off"
        class="h-full w-full rounded-xl border-none bg-transparent pl-11 pr-12 text-base text-color placeholder:text-lGray600 focus:outline-none focus:ring-0"
        [placeholder]="placeholder"
        [value]="term"
        [disabled]="isDisabled"
        [attr.aria-controls]="inputId + '-panel'"
        (focus)="open()"
        (click)="open()"
        (input)="onInput($any($event.target).value)"
        (keydown)="onKeydown($event)"
      />

      <button
        type="button"
        class="absolute right-3 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-lGray500 transition-colors hover:text-lWhite"
        [disabled]="isDisabled"
        [attr.aria-label]="isOpen ? 'Fechar lista de tags' : 'Abrir lista de tags'"
        [attr.aria-expanded]="isOpen"
        [attr.aria-controls]="inputId + '-panel'"
        (click)="toggle()"
      >
        <l-icon [icon]="isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'" class="text-xl" />
      </button>
    </div>

    @if (isOpen) {
      <div
        [id]="inputId + '-panel'"
        class="absolute left-0 top-full z-30 mt-2 w-full overflow-hidden rounded-xl border border-lGray700 bg-lGray800 shadow-lg"
      >
        @if (isLoading) {
          <div class="flex items-center justify-center gap-2 px-4 py-6 text-sm text-lGray500">
            <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
            Carregando tags...
          </div>
        } @else if (loadErrorMessage) {
          <div class="flex flex-col items-center gap-2 px-4 py-6 text-center text-sm">
            <span class="text-lDanger">{{ loadErrorMessage }}</span>
            <button type="button" class="font-medium text-lPrimary hover:underline" (click)="retry()">
              Tentar novamente
            </button>
          </div>
        } @else if (showEmptySearch) {
          <div class="flex flex-col items-center gap-1 px-4 py-6 text-center">
            <span class="mb-2 flex h-9 w-9 items-center justify-center rounded-full bg-lGray700 text-lGray300">
              <l-icon icon="sell" class="text-lg" />
            </span>
            <span class="text-sm font-semibold text-lWhite">Nenhuma tag encontrada para "{{ trimmedTerm }}"</span>
            @if (canCreate) {
              <span class="text-xs text-lGray500">Crie agora e ela já entra nas tags deste curso</span>
            }
          </div>
        } @else if (showEmptyList) {
          <div class="px-4 py-6 text-center text-sm text-lGray500">Nenhuma tag cadastrada</div>
        } @else {
          <ul class="max-h-60 overflow-y-auto p-2" aria-label="Tags disponíveis">
            @for (tag of options; track trackById($index, tag)) {
              <li>
                <button
                  type="button"
                  class="flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2 text-left text-sm text-lWhite transition-colors hover:bg-lGray700"
                  [class.bg-lGray700]="isSelected(tag)"
                  [attr.aria-pressed]="isSelected(tag)"
                  (click)="onOptionClick(tag)"
                >
                  <span class="inline-block truncate first-letter:uppercase">{{ tag.name }}</span>
                  @if (isSelected(tag)) {
                    <l-icon icon="check" class="text-base text-lWhite" />
                  }
                </button>
              </li>
            }
          </ul>
        }

        @if (canCreate && !isLoading && (!trimmedTerm || !hasExactMatch)) {
          <div class="border-t border-lGray700 p-2">
            <button
              type="button"
              class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-lWhite transition-colors hover:bg-lGray700 disabled:cursor-not-allowed disabled:opacity-50"
              [class.bg-lGray700]="showEmptySearch"
              [disabled]="hasReachedLimit"
              (click)="openCreateModal()"
            >
              <span class="flex h-5 w-5 items-center justify-center rounded-full bg-lPrimary text-lWhite">
                <l-icon icon="add" class="text-sm" />
              </span>
              <span class="truncate">{{ createLabel }}</span>
            </button>
          </div>
        }
      </div>
    }

  </div>

  @if (selected.length > 0) {
    <div class="mt-3 flex w-full flex-wrap gap-2">
      @for (tag of selected; track trackById($index, tag)) {
        <span
          class="inline-flex items-center gap-2 rounded-full border px-3 py-1 text-sm text-lWhite"
          [class.border-lPrimary]="isNew(tag)"
          [class.border-lGray600]="!isNew(tag)"
        >
          <span class="inline-block first-letter:uppercase">{{ tag.name }}</span>

          @if (isNew(tag)) {
            <span class="rounded bg-lPrimary px-1.5 py-px text-[10px] font-semibold uppercase leading-4 text-lWhite">Nova</span>
          }

          <button
            type="button"
            class="cursor-pointer border-none bg-transparent text-lg leading-none text-lGray400 transition-colors hover:text-lWhite disabled:cursor-not-allowed"
            [disabled]="isDisabled"
            [attr.aria-label]="'Remover tag ' + tag.name"
            (click)="remove(tag)"
          >
            &times;
          </button>
        </span>
      }
    </div>
  }

  @if (hasReachedLimit) {
    <p class="mt-2 text-xs text-lGray500">Limite de {{ maxTags }} tags por curso atingido.</p>
  }
</div>
